import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AbstractControl, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {InvitationService} from 'src/app/invitation.service';

@Component({
    selector: 'app-invitation',
    templateUrl: './invitation.component.html',
    styleUrls: ['./invitation.component.scss'],
    standalone: false
})
export class InvitationComponent {
    @Input() addPlaceholderToTeam = false;
    @Output() sent = new EventEmitter<string>();
    isLoading$ = new BehaviorSubject<boolean>(false);
    invited = false;

    invitationForm = new UntypedFormGroup({
        email: new UntypedFormControl('', [Validators.required, Validators.email])
    });

    constructor(private invitation: InvitationService) {
    }

    get email(): AbstractControl {
        return this.invitationForm.get('email');
    }

    submitInvitation() {
        this.invitationForm.markAsTouched();
        if (this.invitationForm.invalid) {
            return;
        }

        this.isLoading$.next(true);
        this.invitation.inviteMember(this.email.value, this.addPlaceholderToTeam)
            .then(() => {
                const email = this.email.value;
                this.email.setValue('');
                this.invited = true;
                this.invitationForm.markAsPristine();
                this.invitationForm.markAsUntouched();
                this.sent.emit(email);
                setTimeout(() => this.invited = false, 5000);
            })
            .catch((error) => {
                console.error('Invitation failed', error);
            })
            .finally(() => {
                this.isLoading$.next(false);
            });
    }
}
